import { useEffect, useState } from "react";
import "./CoinModal.css";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";


// --- number formatter helper ---
function formatNumber(num) {
  if (num == null) return "N/A";

  const abs = Math.abs(num);

  if (abs >= 1_000_000_000_000) {
    return `$${(num / 1_000_000_000_000).toFixed(2)}T`;
  }
  if (abs >= 1_000_000_000) {
    return `$${(num / 1_000_000_000).toFixed(2)}B`;
  }
  if (abs >= 1_000_000) {
    return `$${(num / 1_000_000).toFixed(2)}M`;
  }
  if (abs >= 1_000) {
    return `$${(num / 1_000).toFixed(2)}K`;
  }

  return `$${num.toLocaleString()}`;
}

export default function CoinModal({ symbol, onClose }) {
  const [coin, setCoin] = useState(null);

useEffect(() => {
  setCoin(null);

  async function load() {
    try {
      const url = `${process.env.REACT_APP_COINDETAILAPI}?symbol=${symbol}`;
      console.log("Fetching coin URL:", url);
      const res = await fetch(url);

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      setCoin(data);
    } catch (err) {
      console.error("Failed to load coin:", err);
      setCoin({ name: "Error", symbol, price: "N/A" }); // fallback
    }
  }

  load();
}, [symbol]);

  if (!coin) {
  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <button className="close-btn" onClick={onClose}>×</button>
        <p>Loading coin data...</p>
      </div>
    </div>
  );
}

  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <button className="close-btn" onClick={onClose}>×</button>

        <h1>{coin.name}</h1>
        <h2>{coin.symbol.toUpperCase()} = ${Number(coin.price).toLocaleString()}</h2>

        <div className="stats">
          <div>Market Cap {formatNumber(coin.marketCap)}</div>
          <div>24h Volume {formatNumber(coin.volume24h)}</div>
        </div>

        <div className="performance">
          <div>5m {coin.change5m != null ? coin.change5m.toFixed(2) + "%" : "N/A"}</div>
          <div>15m {coin.change15m != null ? coin.change15m.toFixed(2) + "%" : "N/A"}</div>
          <div>1h {coin.change1h != null ? coin.change1h.toFixed(2) + "%" : "N/A"}</div>
          <div>24h {coin.change24h != null ? coin.change24h.toFixed(2) + "%" : "N/A"}</div>
        </div>

        <div className="chart-container">
  <ResponsiveContainer width="100%" height={200}>
    <LineChart data={coin.chart} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
      <XAxis
        dataKey="timestamp"
        tickFormatter={(t) =>
          new Date(t).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        }
      />
      <YAxis
        domain={["auto", "auto"]}
        tickFormatter={(v) => `$${v.toLocaleString()}`}
      />
      <Tooltip
        formatter={(value) => `$${value.toLocaleString()}`}
        labelFormatter={(label) => new Date(label).toLocaleTimeString()}
      />
      <Line
        type="monotone"
        dataKey="price"
        stroke="#4caf50"
        strokeWidth={2}
        dot={false}
      />
    </LineChart>
  </ResponsiveContainer>
</div>
      </div>
    </div>
  );
}
